/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import { connect } from 'react-redux'
import base64 from 'app/state/utils/base64'
import UIkit from 'uikit'

// Components
import OrganizationLayout from 'app/views/containers/Organizations/components/Layout'
import Loader from 'app/views/components/Loader'
import Icon from 'app/views/components/Icon'
import settings from 'settings'
import GenericModal from 'app/views/components/Modals/GenericModal'
import AsssessmentDetail from 'app/views/components/AssessmentDetail'

// Redux
import {
  fetchAssessments,
  getAssessmentReportDetail,
  createOrUpdateAssessment,
  deleteAssessment,
} from 'app/state/modules/assessments'
import {
  getTeamDetails,
} from 'app/state/modules/hacker'

class Assessments extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedFilterLanguage: null,
      loadingAssessmentDetails: true,
      assessmentDetail: null,
      assessment: null,
      assessmentToDelete: null,
    }
    this.handleChangeFilterLanguage = this.handleChangeFilterLanguage.bind(this)
    this.renderLockMessage = this.renderLockMessage.bind(this)
    this.compare = this.compare.bind(this)
    this.modal = React.createRef()
    this.modalNew = React.createRef()
    this.modalTemplates = React.createRef()
    this.modalInvite = React.createRef()
  }

  componentDidMount() {
    this.props.getTeamDetails(this.props.match.params.organization_uuid)
    this.props.fetchAssessments(this.props.match.params.organization_uuid)
  }

  handleChangeFilterLanguage(e) {
    this.setState({
      selectedFilterLanguage: e.target.value === '' ? null : e.target.value,
    })
  }

  compare(a, b) {
    if (a.name < b.name) {
      return -1
    }
    if (a.name > b.name) {
      return 1
    }
    return 0
  }

  showDeleteAssessmentModal(assessment) {
    this.state.assessmentToDelete = assessment
    this.modalDeleteAssessment.show()
  }

  onDetails(assessment) {
    this.setState({
      loadingAssessmentDetails: true,
    }, () => {
      this.modal.current.show()
      this.props.getAssessmentReportDetail(
        this.props.match.params.organization_uuid,
        assessment.uuid,
        (data) => {
          this.setState({
            loadingAssessmentDetails: false,
            assessmentDetail: data,
            assessment,
          })
        },
      )
    })
  }

  renderHackeduAssessments() {
    const { selectedFilterLanguage } = this.state
    if (this.props.hackeduAssessments.length === 0) {
      return (
        <tr>
          <td
            colSpan="5"
            className="uk-text-center"
          >
            No Default Assessment
          </td>
        </tr>
      )
    }
    return this.props.hackeduAssessments.map((assessment) => {
      if (selectedFilterLanguage === null || selectedFilterLanguage === assessment.metadata.language.name) {
        return (
          <React.Fragment key={assessment.uuid}>
            <tr>
              <td>
                {settings.engines[assessment.metadata.language.name]}
              </td>
              <td>
                {settings.frameworks[assessment.metadata.framework.name]}
              </td>
              <td>
                {settings.apps[assessment.metadata.app]}
              </td>
              <td className="uk-text-right uk-flex uk-flex-middle uk-flex-right">
                <button
                  className="uk-button uk-button-primary uk-button-small"
                  type="button"
                  onClick={() => {
                    this.modalTemplates.current.hide()
                    this.modalNew.current.hide()
                    this.props.history.push({
                      pathname: `/admin/${this.props.match.params.organization_uuid}/assessments/add`,
                      state: {
                        assessmentUUID: assessment.uuid,
                        isTemplate: true,
                      },
                    })
                  }}
                >
                  Use Template
                </button>
              </td>
            </tr>
          </React.Fragment>
        )
      }
      return null
    })
  }

  renderLockMessage(className) {
    return (
      <p className={`uk-text-muted uk-width-2-3 uk-text-center uk-align-center${className ? ` ${className}` : ''}`}>
        <i className="ri-lock-line ri-2x" />
        <br />
        Email
        &nbsp;
        <a href="mailto:assessments@hackedu.com">assessments@hackedu.com</a>
        &nbsp;
        to schedule a call to review your results, what they mean, and how
        they compare to other companies in your industry.
      </p>
    )
  }

  renderScore(assessment) {
    if (!this.props.ownsLicenses && this.props.assessmentLock) {
      return (
        <Icon
          name="lock"
          style={{ cursor: 'pointer' }}
          onClick={() => {
            UIkit.modal.dialog(`<p class="uk-text-muted uk-modal-body uk-text-center">
            <br/>
            <i class="ri-lock-line ri-2x"></i>
            <br/>
            Email
            &nbsp;
            <a href="mailto:assessments@hackedu.com">assessments@hackedu.com</a>
            &nbsp;
            to schedule a call to review your results, what they mean, and how
            they compare to other companies in your industry.
          </p>`)
          }}
        />
      )
    }
    return typeof assessment.average_score === 'number' ? (
      `${assessment.average_score} / ${assessment.max_score} (${((assessment.average_score / assessment.max_score) * 100).toFixed(0)}%)`
    ) : ' - '
  }

  render() {
    if (
      !this.props.hasLoadedOrganizations
      || this.props.loadingAssessments
    ) {
      return <Loader visible />
    }
    return (
      <OrganizationLayout
        {...this.props}
        active="assessments"
        data-test-id="organization-assessments-component"
      >
        <div className="uk-inline uk-width-1-1">
          <h1 className="uk-inline">
            Secure Coding Assessments
          </h1>
          {this.props.ownsLicenses && (
            <button
              type="button"
              className="uk-button uk-button-primary uk-align-right"
              onClick={() => {
                this.modalNew.current.show()
              }}
            >
              Create Assessment
            </button>
          )}
        </div>
        {!this.props.ownsLicenses && this.props.assessmentLock && (
          <p className="uk-text-emphasis uk-text-center uk-width-1-1 uk-align-center">
            Welcome to the Free HackEDU Assessment. Click on the "Invite Users" button below to send to your team. Your team will register and be on boarded and directed to the assessment. Once users start taking the assessment you will see them show up in the reporting. If you have any questions please use the chat on the bottom right.
          </p>
        )}
        <table className="uk-table uk-table-divider uk-table-middle">
          {this.props.customAssessments.length > 0 && (
            <thead>
              <tr>
                <th>
                  Title
                </th>
                <th className="uk-text-center">
                  Languages
                </th>
                <th className="uk-text-center">
                  Frameworks
                </th>
                <th className="uk-text-center">
                  Apps
                </th>
                <th className="uk-text-center">
                  Average Score
                </th>
                <th />
              </tr>
            </thead>
          )}
          <tbody>
            {this.props.customAssessments.length === 0 && (
              <tr><td colSpan="6" className="uk-text-center">You haven't created an assessment.</td></tr>
            )}
            {this.props.customAssessments.map((assessment) => (
              <React.Fragment key={assessment.uuid}>
                <tr>
                  <td>
                    <a
                      onClick={this.onDetails.bind(this, assessment)}
                    >
                      {assessment.title}
                    </a>
                  </td>
                  <td className="uk-text-center">
                    <div className="uk-flex uk-flex-column uk-flex-middle uk-flex-center">
                      {(Array.isArray(assessment.metadata.language) ? assessment.metadata.language : [assessment.metadata.language]).sort(this.compare).map((l) => <label key={l.name} className="uk-label uk-label-primary uk-margin-small-bottom uk-width-2-3">{settings.engines[l.name]}</label>)}
                    </div>
                  </td>
                  <td className="uk-text-center">
                    <div className="uk-flex uk-flex-column uk-flex-middle uk-flex-center">
                      {(Array.isArray(assessment.metadata.framework) ? assessment.metadata.framework : [assessment.metadata.framework]).sort(this.compare).map((f) => <label key={f.name} className="uk-label uk-label-secondary uk-margin-small-bottom uk-width-2-3">{settings.frameworks[f.name]}</label>)}
                    </div>
                  </td>
                  <td className="uk-text-center">
                    <div className="uk-flex uk-flex-column uk-flex-middle uk-flex-center">
                      {(Array.isArray(assessment.metadata.apps) ? assessment.metadata.apps : [assessment.metadata.app]).sort().map((a) => <label key={a} className="uk-label uk-label-success uk-margin-small-bottom uk-width-2-3">{settings.apps[a]}</label>)}
                    </div>
                  </td>
                  <td className="uk-text-center">
                    {this.renderScore(assessment)}

                  </td>
                  <td style={{ minWidth: 300, textAlign: 'right', flex: '1 1' }}>
                    {/*
                    <Icon
                      name="file-copy"
                      data-uk-tooltip="Use as template"
                      className="uk-margin-right uk-text-emphasis"
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        this.props.history.push({
                          pathname: `/admin/${this.props.match.params.organization_uuid}/assessments/add`,
                          state: {
                            assessmentUUID: assessment.uuid,
                            isTemplate: true,
                          },
                        })
                      }}
                    />
                    <Icon
                      name="edit"
                      data-uk-tooltip="Edit"
                      className={`uk-margin-right${!assessment.editable ? ' uk-text-muted' : ' uk-text-emphasis'}`}
                      style={{ cursor: 'pointer' }}
                      uk-tooltip={!assessment.editable ? 'Some users already started this assessment. Can\'t be edited.' : null}
                      onClick={() => {
                        if (assessment.editable) {
                          this.props.history.push(`/admin/${this.props.match.params.organization_uuid}/assessments/edit/${assessment.uuid}`)
                        }
                      }}
                    />
                    */}
                    <button
                      className="uk-button uk-button-secondary uk-button-small uk-margin-small-right"
                      type="button"
                      onClick={() => {
                        this.setState({
                          assessmentTeams: assessment.teams,
                        }, () => {
                          this.modalInvite.current.show()
                        })
                      }}
                    >
                      Invite Users
                    </button>
                    <button
                      className="uk-button uk-button-primary uk-button-small"
                      type="button"
                      onClick={this.onDetails.bind(this, assessment)}
                    >
                      Details
                    </button>
                  </td>
                </tr>
              </React.Fragment>

            ))}
          </tbody>
        </table>

        {!this.props.ownsLicenses && this.props.assessmentLock && (
          this.renderLockMessage()
        )}

        <GenericModal
          closeOnClickOverlay
          width="uk-width-2-5"
          id="assessment-detail-modal-new"
          title="Create Assessment"
          noButtons
          body={(
            <>
              <p>Do you want to create an assessment from scratch or use one of our templates?</p>
              <div className="uk-text-right">
                <button
                  className="uk-button uk-button-primary"
                  type="button"
                  onClick={() => {
                    this.modalNew.current.hide()
                    this.props.history.push(`/admin/${this.props.match.params.organization_uuid}/assessments/add`)
                  }}
                >
                  Create  from scratch
                </button>
                <button
                  className="uk-button uk-button-secondary uk-margin-left"
                  type="button"
                  onClick={() => {
                    this.modalTemplates.current.show()
                  }}
                >
                  Use template
                </button>
              </div>
            </>
          )}
          ref={this.modalNew}
        />
        <GenericModal
          closeOnClickOverlay
          width="uk-width-2-3"
          id="assessment-detail-modal-templates"
          title="Pick Assessment Template"
          noButtons
          body={(
            <>
              <div className="uk-width-1-3">
                <label className="uk-form-label">Filter by language</label>
                <div className="uk-form-controls">
                  <select
                    className="uk-select"
                    id="add-plan-select"
                    onChange={this.handleChangeFilterLanguage}
                  >
                    <option value="">
                      Show All
                    </option>
                    {([...new Set(this.props.hackeduAssessments.map((i) => i.metadata.language.name))]).map((language) => (
                      <option key={language} value={language}>
                        {settings.engines[language]}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <table className="uk-table uk-table-divider uk-table-middle">
                <thead>
                  <tr>
                    <th>Language</th>
                    <th>Framework</th>
                    <th>App</th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {this.renderHackeduAssessments()}
                </tbody>
              </table>
            </>
          )}
          ref={this.modalTemplates}
        />
        <GenericModal
          closeOnClickOverlay
          width="uk-width-2-3"
          id="assessment-detail-modal"
          title={this.state.loadingAssessmentDetails ? null : `${(this.state.assessment || {}).title || ` Default Assessment Details: ${settings.apps[((this.state.assessment || {})).app]}`}`}
          noButtons
          body={(
            <AsssessmentDetail
              lockContent={!this.props.ownsLicenses && this.props.assessmentLock}
              renderLockMessage={this.renderLockMessage}
              createOrUpdateAssessment={this.props.createOrUpdateAssessment}
              showDeleteAssessmentModal={this.showDeleteAssessmentModal.bind(this)}
              assessment={this.state.assessment}
              assessmentDetail={this.state.assessmentDetail}
              loadingAssessmentDetails={this.state.loadingAssessmentDetails}
              match={this.props.match}
              onUpdate={(state) => this.setState({
                ...state,
              })}
            />
          )}
          ref={this.modal}
        />
        <GenericModal
          closeOnClickOverlay
          width="uk-width-2-5"
          id="assessment-invite-modal"
          title="Invite Users to Assessment"
          noButtons
          body={(
            <>
              {(this.state.assessmentTeams || []).length === 0 ? (
                <p className="uk-text-small uk-text-emphasis uk-padding-bottom">
                  To assign an assessment to your users go to Training Plans and
                  create a new or modify an existing plan to include the
                  assessment. Then assign that training plan to the users you
                  would like to assess.
                </p>
              ) : (
                  <p className="uk-text-small uk-text-emphasis uk-padding-bottom">
                    Click the "Copy Invite Link" button below and send that to
                    members of your team to on-board and take the assessment.
                  </p>
              )}

              <table className="uk-table uk-table-divider uk-table-middle">
                <tbody>
                  {(this.state.assessmentTeams || []).map((team) => {
                    if (team.is_organization) {
                      return (
                        <tr key="organization">
                          <td>Invite to Organization</td>
                          <td className="uk-text-right">
                            <button
                              onClick={() => {
                                const { token } = this.props
                                navigator.clipboard.writeText(`${settings.urls.app}/invite/${token}`).then(() => {
                                  UIkit.notification({
                                    message: 'Invitation copied',
                                    status: 'success',
                                    pos: 'top-center',
                                    timeout: 5000,
                                  })
                                  this.modalInvite.current.hide()
                                }, (err) => {
                                  console.error('Async: Could not copy text: ', err)
                                })
                              }}
                              className="uk-button uk-button-primary uk-button-small"
                              type="button"
                            >
                              Copy Invite Link
                            </button>
                          </td>
                        </tr>
                      )
                    }
                    return (
                      <tr key={team.uuid}>
                          <td>
                              Invite to team "{team.name}"
                          </td>
                        <td className="uk-text-right">
                          <button
                            onClick={() => {
                              const token = base64.encode(`${this.props.token}@${team.uuid}`).replace('==', '')
                              navigator.clipboard.writeText(`${settings.urls.app}/invite/${token}`).then(() => {
                                UIkit.notification({
                                  message: 'Invitation copied',
                                  status: 'success',
                                  pos: 'top-center',
                                  timeout: 5000,
                                })
                                this.modalInvite.current.hide()
                              }, (err) => {
                                console.error('Async: Could not copy text: ', err)
                              })
                            }}
                            className="uk-button uk-button-primary uk-button-small"
                            type="button"
                          >
                            Copy invite link
                          </button>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </>
          )}
          ref={this.modalInvite}
        />

        <GenericModal
          closeOnClickOverlay
          title="Delete Assessment"
          ref={(ref) => { this.modalDeleteAssessment = ref }}
          id="delete-assessment-modal"
          body={(
                <>
                  <p>Are you sure you want delete this assessment?</p>
                </>
            )}
          buttons={(
                <button
                  type="button"
                  className="uk-button uk-button-danger uk-margin-left"
                  onClick={() => {
                    this.props.deleteAssessment(
                      this.props.match.params.organization_uuid,
                      this.state.assessmentToDelete.uuid,
                      () => {
                        this.modalDeleteAssessment.destroy()
                        this.modal.current.hide()
                        this.props.fetchAssessments(this.props.match.params.organization_uuid)
                      },
                    )
                  }}
                >
                  Delete
                </button>
            )}
        />
      </OrganizationLayout>
    )
  }
}

const mapStatetToProps = (state) => ({
  organizations: state.hacker.organizationsList,
  hasLoadedOrganizations: state.hacker.hasLoadedOrganizations,

  organizationsHash: state.hacker.organizationsHash,

  loadingAssessments: state.assessments.loadingAssessments,
  customAssessments: state.assessments.customAssessments,
  hackeduAssessments: state.assessments.assessmentTemplates,
  token: state.hacker.currentTeamDetails.token,
  assessmentLock: state.hacker.currentTeamDetails.assessment_lock,
  ownsLicenses: state.hacker.currentTeamDetails.owns_licenses,
})

export default connect(mapStatetToProps, {
  fetchAssessments,
  getAssessmentReportDetail,
  createOrUpdateAssessment,
  deleteAssessment,
  getTeamDetails,
})(Assessments)
